import { Injector } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { AppTextService } from '@fi-shared/app-text';

export class BillingPaymentModel {
    ObjectType: any;
    BusinessUnitId: number;
    BusinessUnitName: string;
    IsUnitHeadquarter: boolean;

    private appTextService: AppTextService;

    constructor(data, injector: Injector) {
        this.appTextService = injector.get(AppTextService);

        this.ObjectType = null;
        this.BusinessUnitId = 0;
        this.BusinessUnitName = '';
        this.IsUnitHeadquarter = false;
        Object.defineProperty(this, 'paymentTypeName', {
            get: this.getPaymentTypeName,
        });
        if (data) this.Initialize(data);
    }

    private Initialize(data) {
        Object.assign(this, data);
    }

    getPaymentTypeName() {
        switch (this.ObjectType) {
            case ObjectTypes.CreditCard:
                return this.appTextService.get('credit_card_information');
            case ObjectTypes.Invoice:
                return this.appTextService.get('invoice_information');
            default:
                return 'Unknown payment type';
        }
    }

    isCreditCardInformation() {
        return this.ObjectType == ObjectTypes.CreditCard;
    }

    isInvoiceInformation() {
        return this.ObjectType == ObjectTypes.Invoice;
    }
}
